import { useMemo } from 'react';
import { boService } from 'shared/services';
import useRequest from '../useRequest';
import { TimePeriod } from 'shared/models';

export const usePeriodTimeBigBagQuery = (query: { service: string }) => {
  return useMemo(() => {
    const queryParams = { ...query };

    return [queryParams];
  }, []);
};

export const usePeriodTimeBigBag = (query: { service: string }) => {
  const action = async () => {
    const response = await boService.getPeriodTimeBigBags(query);
    return {
      periodsDepositTimeBigBag: response?.list_periods_time?.filter((item) => !item.disable),
    };
  };
  return useRequest<{ periodsDepositTimeBigBag: TimePeriod[] }>({
    action,
    params: query,
    default: {
      periodsDepositTimeBigBag: [],
    },
  });
};
